import { NumericInputType } from '@procsea/design-system'

import { QuantityUnitSlug } from 'src/types'

interface IsInvalidDecimalQuantityArgs {
  quantity: NumericInputType
  unitSlug?: QuantityUnitSlug
}

export const isInvalidDecimalQuantity = ({
  quantity,
  unitSlug,
}: IsInvalidDecimalQuantityArgs): boolean =>
  unitSlug !== undefined &&
  unitSlug !== QuantityUnitSlug.KG &&
  typeof quantity === 'number' &&
  !Number.isInteger(quantity)

export const DECIMAL_QUANTITY_ERROR_MESSAGE = gettext(
  'Decimal quantities are not allowed for this unit'
)
